import React from 'react'

function AboutOriginStory() {
    const stats = [
        { value: '5+ Years', label: 'In business' },
        { value: '95%+', label: 'Client retention' },
        { value: '25+', label: 'Clients served' },
    ]
    return (
        <section className="about-origin td-section td-section--about-origin rts-section-gap">
            <div className="container">
                <div className="row justify-content-center mb-4 mb-lg-5">
                    <div className="col-xl-10 col-lg-11">
                        <div className="td-section-head text-center about-origin__head">
                            <p className="td-section-label">Our Story</p>
                            <h2 className="td-section-title">
                                We Didn&apos;t Start With a Business Plan. We Started With a Problem.
                            </h2>
                            <div className="td-title-rule td-title-rule--center mx-auto" aria-hidden="true" />
                        </div>
                    </div>
                </div>

                <div className="row g-4 g-xl-5 align-items-start justify-content-center">
                    <div className="col-lg-7">
                        <div className="about-origin__panel">
                            <div className="about-origin__body">
                                <p className="disc">
                                    It was 2020. A healthcare clinic in the United States needed real operational
                                    help—not another vendor promising results from a pitch deck. Four professionals who
                                    had spent years working across healthcare IT and operations decided to actually
                                    show up, set up a team and do the work.
                                </p>
                                <p className="disc">
                                    No investor roadshows. No flashy launch. Just a small office, a dedicated team and
                                    one client who needed things done properly.
                                </p>
                                <p className="disc">
                                    Within two months, that clinic&apos;s denial rate dropped from 18 percent to under 6
                                    percent. Within six months, they brought us to their call center too. That first
                                    client didn&apos;t become a success story. They became the standard we&apos;ve held
                                    every engagement to since.
                                </p>
                                <p className="disc">
                                    From there, we grew the way we think every services company should—by doing excellent
                                    work, earning referrals and never taking on more than we could serve well.
                                </p>
                                <p className="disc about-origin__lead">
                                    Today, TechDigit Solutions delivers medical billing and revenue cycle management,
                                    enterprise cybersecurity, healthcare call center outsourcing and professional content
                                    writing to clients across the United States.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-5">
                        <aside className="about-origin__aside" aria-label="Highlights and results">
                            <div className="about-origin__metric-card">
                                <p className="about-origin__metric-label">First clinic engagement</p>
                                <div className="about-origin__metric-compare" aria-hidden="true">
                                    <span className="about-origin__metric-from">18%</span>
                                    <span className="about-origin__metric-arrow">
                                        <i className="fas fa-long-arrow-alt-right" />
                                    </span>
                                    <span className="about-origin__metric-to">&lt;6%</span>
                                </div>
                                <p className="about-origin__metric-caption">Denial rate — within two months</p>
                            </div>

                            <blockquote className="about-origin__quote">
                                <p>Doing it right was worth more than doing it fast.</p>
                            </blockquote>

                            <div className="about-origin-stats about-origin-stats--rail" role="list">
                                {stats.map((s, i) => (
                                    <div key={i} className="about-origin-stat" role="listitem">
                                        <span className="about-origin-stat__value">{s.value}</span>
                                        <span className="about-origin-stat__label">{s.label}</span>
                                    </div>
                                ))}
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AboutOriginStory
